import React, { useState, useEffect } from 'react'
import api from "../../controller/api"

import { OrderData } from '../../components/Tables';
import Loading from '../../components/Loading';

export default function BookingList() {
    const [bookingList, setBookingList] = useState([])
    const [pageLoading, setPageLoading] = useState(false)

    const fetchBookingData = async () => {
        try {
            const { data: res } = await api.get("/booking/list")
            setBookingList(res?.data.reverse())
        } catch (error) {
            console.error(error?.response?.data?.message);
            if (error?.response?.data?.message === "jwt expired") {
                localStorage.removeItem("user");
                window.location.reload();
            }
        } finally {
            setPageLoading(false)
        }
    }

    const handleBookingStatus = async (id, text) => {
        try {
            await api.put("/booking/status-update", { id, text })
            fetchBookingData()
        } catch (error) {
            console.error(error?.response?.data?.message);
        }
    }

    let sortedData = bookingList.sort((a, b) => b.timeId.localeCompare(a.timeId));

    useEffect(() => {
        setPageLoading(true)
        fetchBookingData()
    }, [])

    if (pageLoading) return <Loading />
    return (
        <div className='dashboar-theme'>
            <div className='table-data'>
                <div className='manage'>
                    <h2>Appointment List</h2>
                    <OrderData
                        bookingList={bookingList}
                        sortedData={sortedData}
                        handleBookingStatus={handleBookingStatus}
                    />
                </div>
            </div>
        </div>
    )
}
